export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إنشاء ودجت لـ"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إلغاء"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الحساب"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["توليد"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الدفع في"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مبلغ الدفع"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الإجراءات عند النجاح"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الإجراءات عند الفشل"])}
}